import { useSyncExternalStore } from "react";
import { UserRole } from "../../interfaces/auth";

function subscribe(callback: () => void) {
  window.addEventListener("storage", callback);
  return () => {
    window.removeEventListener("storage", callback);
  };
}

function getSnapshot(): string | null {
  return localStorage.getItem("userRole");
}

export const useUserRole = (): UserRole | null => {
  const role = useSyncExternalStore(
    subscribe,
    getSnapshot,
    () => null, // Server snapshot
  );
  return (role as UserRole) || null;
}; 